import { useCallback, useState } from 'react';
import {
    GroupTableCustomSortComparators,
    GroupTableMetrics,
    normalizeGroupTableFilterText,
} from '@/components/group-tables/group-table-view-model-primitives';
import { useGroupTableFilterSortViewModel } from '@/components/group-tables/use-group-table-filter-sort-view-model';

type UseGroupTableNameFilterSortViewModelArgs<TData extends GroupTableMetrics> = {
    data: TData[];
    page: number;
    rowsOnPage: number;
    setPage: (page: number) => void;
    setPageCount: (count: number) => void;
    setTotalRows: (count: number) => void;
    sortComparators: GroupTableCustomSortComparators<TData>;
    filterData: (item: TData, normalizedNameFilter: string) => boolean;
};

export const useGroupTableNameFilterSortViewModel = <TData extends GroupTableMetrics>({
    data,
    page,
    rowsOnPage,
    setPage,
    setPageCount,
    setTotalRows,
    sortComparators,
    filterData,
}: UseGroupTableNameFilterSortViewModelArgs<TData>) => {
    const [nameFilter, setNameFilter] = useState('');
    const normalizedNameFilter = normalizeGroupTableFilterText(nameFilter);

    const filterDataWithName = useCallback(
        (item: TData) => filterData(item, normalizedNameFilter),
        [filterData, normalizedNameFilter],
    );

    const tableViewModel = useGroupTableFilterSortViewModel<TData>({
        data,
        page,
        rowsOnPage,
        setPage,
        setPageCount,
        setTotalRows,
        filterData: filterDataWithName,
        sortComparators,
    });

    return {
        nameFilter,
        setNameFilter,
        normalizedNameFilter,
        ...tableViewModel,
    };
};
